import { useFormContext } from 'react-hook-form';
import { EngagementDetail } from '@anytag/graphql';
import { EngagementPostFormValues } from '../types';
import { DefaultTemplate } from './DefaultTemplate';
import { TTCMTemplate } from './TTCMTemplate';

export interface TemplateProps {
  onClose: () => void;
  onSubmit?: () => void;
  engagement: EngagementDetail;
  hasPostMissingMetricsData: boolean;
  initialValues: EngagementPostFormValues;
}
export const Template = ({
  engagement: { id: engagementId, isTtcmCampaign },
  hasPostMissingMetricsData,
  ...restProps
}: TemplateProps) => {
  const { watch } = useFormContext<EngagementPostFormValues>();
  const isTtcmFormValue = watch('isTtcmForm');

  const commonProp = { engagementId, isTtcmCampaign, ...restProps };

  return isTtcmFormValue ? (
    <TTCMTemplate {...commonProp} />
  ) : (
    <DefaultTemplate {...commonProp} hasPostMissingMetricsData={hasPostMissingMetricsData} />
  );
};
